import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Spin } from "antd";

export default function Loader({ style }) {
	return (
		<>
			<Flex align="center" justify="center" gap="middle" style={style}>
				<Spin
					indicator={<LoadingOutlined color="#0F6936" spin />}
					size="large"
					style={{ color: "#0F6936" }}
				/>
			</Flex>
		</>
	);
}
